// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { _x } from '@wordpress/i18n';

// Import recipe builder services
import { duplicateAction } from '@automator/builder/services/item';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-action-menu-button-duplicate' )
export class AutomatorBuilderItemActionMenuButtonDuplicate extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties

	// The item ID (post ID)
	@property( { type: Number, attribute: 'item-id' } ) accessor itemID;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-button
				color="transparent"
				@click=${ this.handleDuplicateItem }
			>
				${ escapeHTML( _x( 'Duplicate', 'Verb', 'uncanny-automator' ) ) }
			</uo-button>
		`;
	}

	/**
	 * Handles the item duplication
	 */
	handleDuplicateItem() {
		duplicateAction(
			this.itemID
		);
	}
}
